import { render, staticRenderFns } from "./receiptMark.vue?vue&type=template&id=4e72b85e&scoped=true"
import script from "./receiptMark.vue?vue&type=script&lang=js"
export * from "./receiptMark.vue?vue&type=script&lang=js"
import style0 from "./receiptMark.vue?vue&type=style&index=0&id=4e72b85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72b85e",
  null
  
)

export default component.exports